<template>
    <div v-if="event.provider ? event.provider.includes('survey') : false || getUserType != 'observer'">
        <div class="question-actions">
            <SurveyHistory
                v-if="event.modified_time"
                :id="event.id"
                :event="event"
                :patient="patient"
                :question="question">
            </SurveyHistory>
            <el-button class="edit-button" @click="showEdit = !showEdit">
                <EditSurveyIcon></EditSurveyIcon>
            </el-button>
        </div>
        <el-dialog :append-to-body="true"
            class="send-now-modal edit-question-modal"
            :visible.sync="showEdit">
            <span slot="title"> Edit answer </span>
            <div class="question-title">
                {{qNum + "."}} {{ question.title }} <span class="question-content">({{ question.question }})</span>
            </div>
            <el-select v-model="updateResponse"
                :multiple="isMultipleSelect"
                :multiple-limit="maxSelectLimit">
                <el-option v-for="option in questionOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value">
                </el-option>
            </el-select>
            <div class="footer">
                <el-button type="text" size="small" class="cancel-button" @click="showEdit = false">
                    Cancel
                </el-button>
                <LoadingButton
                        type="primary"
                        size="small"
                        class="send-button"
                        @click="updateQuestion"
                        :loading="savingEdit">
                    Save
                </LoadingButton>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuestionEdit from './'
import Icons from '../analysis/response/icon'

const radioOptions = Array.from(Array(5)).map((_, index) => ({
    label: index + 1,
    value: index + 1
}))

const starOptions = Array.from(Array(5)).map((_, index) => ({
    label: (index + 1) + ' star',
    value:  String(index)
}))

export default {
    name: 'edit-select',
    extends: QuestionEdit,

    data() {
        return {
            updateResponse: this.getQuestionResponse(),
            questionOptions: this.getQuestionOptions(),
        }
    },

    methods: {
        ...mapActions('provider', [
            'updateSurvey'
        ]),
        updateQuestion() {
            let update = [...this.event.question]
            if(this.updateIndex !== -1)
                update[this.updateIndex] = this.getQuestionUpdate
            else
                update.push(this.getQuestionUpdate)
            console.log('Index - ',this.updateIndex)
            console.log(update)
            //return
            this.savingEdit = true
            this.updateSurvey({
                updateObj: {
                    id: this.event.response,
                    update
                }, 
                surveyId: this.event.id,
                provider: this.event.provider.split(':')[0],
                patient: this.patient.id,
                previousObj: this.event
                })
                .finally(() => {
                    this.savingEdit = false
                    this.showEdit = false
                })
        },
        getQuestionOptions() {
            switch (this.question.type) {
                case 'binary':
                    return [{
                        label: 'Yes',
                        value: 'Yes'
                    }, {
                        label: 'No',
                        value: 'No'
                    }]
                    break
                case 'radio':
                    return radioOptions
                case 'star':
                    return starOptions
                case 'scroller':
                    return  Object.entries(this.question.label).map(([key, value]) => ({
                        value: `${key}::${value}`,
                        label: value ? value : String((parseInt(key) + 1))
                    }))
                case 'slider':
                    return Array.from(Array(this.question.max)).map((_, index) => {
                        const valueIndex = this.question.label[index]
                        return {
                            value: `${index}::${valueIndex ? valueIndex : ' '}`,
                            label: valueIndex ? valueIndex : String((parseInt(index) + 1))
                        }
                    })
                case 'box_select':
                case 'large_image_select':
                case 'small_image_select':
                    return Object.entries(this.question.select).map(([value, label]) => ({
                        value,
                        label
                    }))
                case 'select':
                    return this.question.option.map((value) => ({
                        value,
                        label: value
                    }))
                case 'long_text_bubble':
                    return this.question.options.map(({id, display_text}) => ({
                        value: id,
                        label: display_text
                    }))
                default:
                    return []
            }
        },
        getQuestionResponse() {
            if(!this.response)
                return ''
            switch (this.question.type) {
                case 'binary':
                    return this.response[0]
                case 'radio':
                    return this.response
                case 'star':
                    return Object.keys(this.response)[0]
                case 'scroller':
                case 'slider':
                    return Object.entries(this.response).map(([key, value]) => `${key}::${value ? value : ' '}`)[0]
                case 'box_select':
                case 'large_image_select':
                case 'small_image_select':
                    return Object.keys(this.response)
                case 'select':
                    return this.response
                case 'long_text_bubble':
                    return this.response.map(({id}) => id)
                default:
                    return null
            }
        }
    },

    computed: {
        ...mapGetters(['getUserType']),
        getQuestionUpdate() {
            let update = {
                id: this.question.id,
                answer: null
            }
            switch (this.question.type) {
                case 'binary':
                    update.answer = { 0: this.updateResponse}
                    break
                case 'radio':
                    update.value = this.updateResponse
                    break
                case 'star':
                    update.answer = {
                        [this.updateResponse]: this.question.label[this.updateResponse] ? this.question.label[this.updateResponse] : ''
                    }
                    break
                case 'scroller':
                case 'slider':
                    const [key, response] = this.updateResponse.split('::')
                    update.answer = {
                        [key]: response
                    }
                    break
                case 'box_select':
                case 'large_image_select':
                case 'small_image_select':
                    update.answer = {}
                    if(this.isMultipleSelect)
                        update.answer = this.updateResponse.reduce((acc, rIndex) => ({...acc, [rIndex]: this.question.select[rIndex]}), {})
                    break
                case 'select':
                    update.answer = [...this.updateResponse]
                    break
                case 'long_text_bubble':
                    update.answer = this.question.options.filter(({id}) => this.updateResponse.includes(id))
                        .map(({id, display_text, value}) => ({id, display_text, value}))
            }
            return update
        },
        isMultipleSelect() {
            return ['box_select', 'large_image_select', 'small_image_select', 'select', 'long_text_bubble'].includes(this.question.type)
        },
        maxSelectLimit() {
            return this.question.single ? 1 : 0
        }
    },

    components: {
        ...Icons
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss'
</style>
